/**
 * Puts the button inside the customer's element, and keeps it there.
 *
 * 🔴 A SINGLE-PAGE APP RENDERS THE ELEMENT AFTER US, AND RE-RENDERS IT ON
 *    EVERY ROUTE CHANGE. Looking once at boot found nothing on a React or Vue
 *    navbar, so the button stayed floating in its corner; and when a route
 *    change replaced the navbar, a button that had been placed went with it.
 *    So this watches: it places the button as soon as the element exists, and
 *    again whenever the element it was in is replaced. The callback does two
 *    property reads unless the button needs placing, so it costs nothing on a
 *    busy page. Until an element exists the button floats in its corner.
 */
export interface Placeable {
  mountLauncherInto(selector: string, quiet?: boolean): boolean;
  launcherPlaced(): boolean;
}

export function followLauncherTarget(panel: Placeable, selector: string, warnAfterMs = 10_000): void {
  let placedOnce = panel.mountLauncherInto(selector, true);
  new MutationObserver(() => {
    if (panel.launcherPlaced()) return;
    if (panel.mountLauncherInto(selector, true)) placedOnce = true;
  }).observe(document.documentElement, { childList: true, subtree: true });

  setTimeout(() => {
    if (!placedOnce) {
      console.warn(
        `[Verb] data-verb-launcher="${selector}" has matched no element after 10 seconds, so ` +
          `the button is floating in its corner. It moves in as soon as that element appears.`,
      );
    }
  }, warnAfterMs);
}
